import React from "react";
import { useEffect, useState } from "react";
import { Services } from "../../../api/Services";
import { toast } from "react-toastify";
import UserStats from "../UserStats";
import "react-toastify/dist/ReactToastify.css";
import placeholder from "../../../images/placeholder.png";
import { BASE_URL_MEDIA } from "../../../api/Constants";
import { BASE_URL_COMPETITION } from "../../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

const GroupsModal = ({ setGroupModal, activeid }) => {
  const [clientGroups, setClientGroups] = useState([]);
  const [duplicateGroups, setDuplicateGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchGroup, setSearchGroup] = useState("");
  const [userId, setUserId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const filterGroup = (e) => {
    setSearchGroup(e.target.value);
    const value = e.target.value;
    const filteredResult = clientGroups?.filter((item) =>
      item.title.toLowerCase().includes(value.toLowerCase())
    );
    setClientGroups(value == "" ? duplicateGroups : filteredResult);
  };

  //Api call for get trainer clients Gropus
  const getTrainerClientGroups = async (id) => {
    setIsLoading(true);

    try {
      const result = await Services.getTrainerClientAssignedGroups(id);

      if (result) {
        setGroupModal(true);
        setIsLoading(false);
        setClientGroups(result?.data?.data?.groups);
        setDuplicateGroups(result?.data?.data?.groups);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTrainerClientGroups(activeid);
  }, [activeid]);

  const showUserStats = (id) => {
   // setUserId(id);
   // setShowModal(true);
   const metaToken = localStorage.getItem("token");
   const url = `${BASE_URL_COMPETITION}/user/${id}${metaToken ? "?token=" + metaToken : ""}`;
   window.open(url, "_blank");
  };

  const showGroupProfile = (gid) => {
    //setShowModal(true);
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/all-groups?tab=view-members&g-id=/${gid}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };

  return (
    <div>
      {userId && showModal && (
        <div className="trainer-modal-eventWrapper trainer-modal-eventWrapper-upper">
          <div className="trainer-modal trainer-modal-lg">
            <div className="close" onClick={() => setShowModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <UserStats userId={userId} />
          </div>
        </div>
      )}

      <div className="trainer-modal-eventWrapper">
        <div className="trainer-modal trainer-modal-lg">
          {isLoading && (
            <div className="loaderparent-absolute">
              <div className="loader"></div>
            </div>
          )}
          <div className="close" onClick={() => setGroupModal(false)}>
            <i className="fa fa-times"></i>
          </div>
          <div className="search px-2">
            <input
              type="text"
              className="form-control input"
              placeholder="Search Group by name"
              value={searchGroup}
              onChange={filterGroup}
            />
          </div>

          {clientGroups?.length == 0 && !isLoading && (
            <p className="text-center no_found my-4">No Group Found</p>
          )}
          <div className="group__main_wrapper px-2 mt-3">
            <div className="row">
              {clientGroups?.map((group) => (
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div className="group__wrapper">
                    <div className="image">
                      {group?.image ? (
                        <img style={{ cursor: 'pointer' }}
                          onClick={() => showGroupProfile(group?.id ?? 0)}
                          src={getImageUrl(group?.image, BASE_URL_MEDIA)}
                        />
                      ) : (
                        <img src={placeholder} />
                      )}
                    </div>
                    <div className="px-2 pb-2">
                      <div style={{ cursor: 'pointer' }} onClick={() => showGroupProfile(group?.id ?? 0)}>
                      <p className="group-name">{group?.title}</p>
                      </div>
                      <div className="types">
                        <div className="type">
                          <i class="fa-solid fa-user-group"></i>{" "}
                          {group?.group_type}
                        </div>
                        {group?.start_date && (
                          <div className="type">
                            <i class="fa-regular fa-calendar-days"></i>{" "}
                            {group?.start_date}
                          </div>
                        )}
                        {group?.end_date && (
                          <div className="type">
                            <i class="fa-regular fa-calendar-days"></i>{" "}
                            {group?.end_date}
                          </div>
                        )}
                      </div>
                      <div className="members">
                        {group?.members?.map((member) =>
                          member?.member?.image ? (
                            <img
                              onClick={() => showUserStats(member.member.id)}
                              src={`${BASE_URL_MEDIA}/storage/assets/uploads/${member?.member?.image}`}
                            />
                          ) : (
                            <div
                              onClick={() => showUserStats(member.member.id)}
                              className="placerholder-small"
                            >
                              {member.member?.name.slice(0, 1)}
                            </div>
                          )
                        )}
                      </div>
                      <div class="community-wrapper">
                        {group?.community?.logo && (
                          <img
                            src={`${BASE_URL_MEDIA}/storage/assets/uploads/${group?.community?.logo}`}
                          />
                        )}
                        <div class="info-wrapper">
                          <p class="name">{group?.community?.name}</p>
                          <p class="country">{group?.community?.country}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupsModal;
